<div
  class="app-nav-item"
  [matMenuTriggerFor]="menu"
  #menuTrigger="matMenuTrigger"
  [ngStyle]="menuStyle"
  (mouseenter)="mouseEnter(menuTrigger)"
  (mouseleave)="mouseLeave(menuTrigger)"
>
  <ng-content select="[trigger]"></ng-content>
</div>
<mat-menu #menu="matMenu" [hasBackdrop]="false" [yPosition]="menuPositionY" class="zit-tooltip">
  <div (mouseenter)="mouseEnter(menuTrigger)" (mouseleave)="mouseLeave(menuTrigger)">
    <ng-content select="[content]"></ng-content>
  </div>
</mat-menu>
